import React from 'react'
import { Link } from "react-router-dom";


const GeneralMedicine = () => {
  return (
    <>
      <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
        <div className="auto-container">
          <h2>General Medicine</h2>
          <ul className="bread-crumb clearfix">
            <li><Link to="/">Home</Link></li>
            <li style={{ color: "green" }}>General Medicine</li>
          </ul>
        </div>
      </section>
      {/* <marquee width="100%" direction="left" height="" ><br />
        <b className='' style={{ fontSize: "18px", color: "green" }}>अन्य सुविधा - ECG | USG | X-Ray | ICU | Ventilator । फामेसर्सी । पैथालॉली</b>
      </marquee> */}


      <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-100px" }}>
        <div className="auto-container">
          {/* <p className='abcd' style={{ fontSize: "18px", color: "white", textAlign: "center" }}>
            ✅ ओ.पी.डी. प्रत्येक दिन (सोमवार से शनिवार) ✅ दोपहर 2 बजे से 4 बजे । सायं 6 बजे से 8 बजे तक
          </p> */}

          <div className="row clearfix">
            {/* Sidebar Side */}
            <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
              <aside className="sidebar sticky-top">
                {/* Department Widget */}
                <div className="sidebar-widget department-widget">
                  <div className="widget-content">
                    <ul className="department-list">
                      <li className="active"><Link to="/general-medicine">General Medicine</Link></li>
                      <li ><Link to="/gastroenterology">Gastroenterology</Link></li>
                      <li><Link to="/orthopedic">Orthopedic</Link></li>
                      <li><Link to="/general-surgery">General Surgery</Link></li>
                      <li><Link to="/neurology">Neurology</Link></li>
                      <li><Link to="/neurosurgery">Neurosurgery</Link></li>
                      <li><Link to="/gynaecology">Gynaecology</Link></li>
                      <li><Link to="/paediatrics">Paediatrics</Link></li>
                      <li ><Link to="/neuropsychiatrist">Neuropsychiatrist</Link></li>
                    </ul>
                  </div>
                </div>
                {/* Time Widget */}
                {/* <div className="sidebar-widget time-widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <span className="clock_icon flaticon-clock" />
                      <h4>Working Time</h4>
                      <ul className="working-time_list">
                        <li>Mon-Thu <span>08:00 - 20:00</span></li>
                        <li>Friday <span>07:00 - 22:00</span></li>
                        <li>Saturday <span>08:00 - 18:00</span></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Time Widget */}
                <div className="sidebar-widget contact-info_widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <h4>Contact Info</h4>
                      <ul className="contact-info_widget-list">
                        <li><a style={{ color: "black" }} to='https://share.google/fCIHbcmFHPs4QBm5t' target="_blank">✅ ओ.पी.डी. प्रत्येक दिन (सोमवार से शनिवार)</a></li>
                        <li><a style={{ color: "black" }} to="mailto:satnaswastikhospital@gmail.com">✅ दोपहर 2 बजे से 4 बजे । सायं 6 बजे से 8 बजे तक</a></li>
                        {/* <li><span className="icon fa-solid fa-clock fa-fw" />Mon - Sat 8:00 - 6:30, <br /> Sunday - CLOSED</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Expert Widget */}
                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                  <span className="color-layer" />
                  <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                  <Link to="/appointment" className="theme-btn btn-style-one">
                    <span className="btn-wrap">
                      <span className="text-one">Book Appointment</span>
                      <span className="text-two">Book Appointment</span>
                    </span>
                  </Link>
                  <div className="image">
                    <img src="assets/images/resource/doctor-1.png" alt />
                  </div>
                </div>
              </aside>
            </div>
            {/* Content Side */}
            <div className="content-side col-lg-8 col-md-12 col-sm-12">
              <div className="department-detail">
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/General Medicine.avif" alt />
                  </div>
                  <h3>General Medicine</h3>
                  <p>At Satna Swastik Hospital, the General Medicine or Internal Medicine Department treats adult medical issues that don't require surgery. Diabetes mellitus, high blood pressure, heart disease, rheumatism, asthma, and other illnesses are frequently seen in this field. This department's primary responsibility is to diagnose, treat, and, if feasible, put the patient on the path to recovery.</p>

                  <h3>Conditions we treat</h3>
                  <div className="graph-outer">
                    <div className="row clearfix">
                      <div className="column col-lg-6 col-md-6 col-sm-12">
                        <ul className="list">
                          <li>डायबिटी से संबंधित रोगों का ईलाज</li>
                          <li>ब्लड प्रेशर से संबंधित रोगों का ईलाज</li>
                          <li>थायरॉइड का ईलाज</li>
                          <li>अस्थमा (दमा) एवं श्वास संबंधी रोगों का ईलाज</li>
                          <li>पेट से संबंधित सभी समस्याओं का ईलाज</li>
                          <li> सभी प्रकार के सामान्य बुखार का ईलाज</li>
                          <li> डेंगू, मलेरिया, टायफाइड का ईलाज</li>

                        </ul>
                      </div>
                      <div className="column col-lg-6 col-md-6 col-sm-12">
                        <ul className="list">
                          <li> अन्य आन्तरिक रोगों का ईलाज</li>
                          <li> लीवर, किडनी एवं फेफेड़ों से संबंधित समस्याओं का ईलाज सफलतापूर्वक किया जाता है</li>
                          <li> ब्रेन स्ट्रोक</li>
                          <li> पोइजनिंग</li>
                          <li> साँप का काटना</li>
                          <li> भर्ती की सुविधा</li>
                          <li> अन्य सभी अपाताकालीन सुविधाएँ उपलब्ध हैं </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <h3>Specialists</h3>
                  <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                      <div className="image">
                        <img src="assets/img/Dr. Divyant Gupta.webp" alt style={{ width: "200px", height: "200px", borderRadius: "100px" }} />
                      </div>
                      <div className="lower-content">
                        <div className="content">
                          <h5 style={{ textAlign: "justify", marginTop: "-22px" }}><a to="#" style={{ textAlign: "center" }}>Dr. Divyant Gupta</a></h5>
                          <div className="designation" style={{ textAlign: "justify" }}>MBBS MD Medicine</div>
                        </div>
                        {/* <a to="#" className="plus-box flaticon-plus" /> */}
                      </div>
                    </div>
                  </div>
                  {/* <div className="image">
                    <img src="assets/img/Dr. Divyant Gupta.webp" alt style={{width:"200px", height:"200px", borderRadius:"100px"}} />
                  </div>
                  <p><strong>Electrocardiogram (ECG or EKG): </strong>this records the electrical activity of the heart.</p> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




    </>
  )
}

export default GeneralMedicine